<template>
  <RouterView v-slot="{ Component }">
    <KeepAlive include="*">
      <Component :is="Component" />
    </KeepAlive>
  </RouterView>
</template>
<script>
// import { mapGetters } from 'vuex'
export default {
  // computed: {
  //   ...mapGetters(['isGlobalLoading']),
  // },
}
</script>
